import React from "react";

export default function Store() {
  return <div>store</div>;
}
